/**
 * App-level provider composition.
 *
 * Enviar is guest-first: no accounts, no DB, 100% local. The only asynchronous
 * startup resource is the lingui catalog (i18n).
 */

import type { ParentComponent } from "solid-js";

import { I18nProvider } from "@/providers/i18n-provider";
import { KernelProvider } from "@/providers/kernel-provider";

export const AppProviders: ParentComponent = (props) => (
  <I18nProvider>
    <KernelProvider>{props.children}</KernelProvider>
  </I18nProvider>
);
